import ServiceIndex from '@/views/service/Index'
import ServiceTasksIndex from '@/views/service/serviceTasks/Index'
import ServiceTaskTypesIndex from '@/views/service/serviceTaskTypes/Index'
import InventoryIndex from '@/views/service/inventory/Index'
import InventoryItems from '@/views/service/inventory/index/InventoryItems'
import InventoryItemsIssued from '@/views/service/inventory/index/InventoryItemsIssued'
import InventoryItemsActivity from '@/views/service/inventory/index/InventoryItemsActivity'
import ServiceCostReportsIndex from '@/views/service/serviceCostReports/Index'
import ChecklistIndex from '@/views/service/checklists/Index'
import ChecklistPrint from '@/components/service/checklists/ChecklistPrint'
import ServiceCostReportPrint from '@/components/service/serviceCostReports/ServiceCostReportPrint'
import YachtIndex from '@/views/service/yachts/Index'
import YachtDetails from '@/views/business/yachts/Details'
import StatsIndex from '@/views/service/stats/Index'
import YachtDashboard from '@/views/business/yachts/details/Dashboard'
import YachtDelivery from '@/views/business/yachts/details/Delivery'
import YachtDocuments from '@/views/business/yachts/details/Documents'
import YachtFinance from '@/views/business/yachts/details/Finance'
import YachtHistory from '@/views/business/yachts/details/History'
import YachtBooking from '@/views/business/yachts/details/Booking'
import YachtPhotos from '@/views/business/yachts/details/Photos'
import YachtSpecs from '@/views/business/yachts/details/Specs'
import YachtComments from '@/views/business/yachts/details/Comments'

export default [
  {
    path: '/service',
    name: 'service',
    redirect: { name: 'serviceTasks' },
    component: ServiceIndex,
    children: [
      {
        path: 'dashboard',
        name: 'serviceDashboard',
        component: StatsIndex
      },
      {
        path: 'tasks',
        name: 'serviceTasks',
        component: ServiceTasksIndex
      },
      {
        path: 'task-types',
        name: 'serviceTaskTypes',
        component: ServiceTaskTypesIndex
      },
      {
        path: 'inventory',
        component: InventoryIndex,
        children: [
          {
            path: '',
            name: 'inventoryItems',
            component: InventoryItems
          },
          {
            path: 'issued',
            name: 'inventoryItemsIssued',
            component: InventoryItemsIssued
          },
          {
            path: 'activity',
            name: 'inventoryItemsActivity',
            component: InventoryItemsActivity
          }
        ]
      },
      {
        path: 'cost-reports',
        name: 'serviceCostReports',
        component: ServiceCostReportsIndex
      },
      {
        path: 'cost-reports/:id/print',
        name: 'serviceCostReportPrint',
        component: ServiceCostReportPrint
      },
      {
        path: 'checklists',
        name: 'checklists',
        component: ChecklistIndex
      },
      {
        path: 'checklists/:id/print',
        component: ChecklistPrint
      },
      {
        path: 'yachts',
        name: 'serviceYachts',
        component: YachtIndex
      },
      {
        path: 'yacht/:id',
        component: YachtDetails,
        children: [
          {
            path: '',
            name: 'serviceYachtDashboard',
            component: YachtDashboard
          },
          {
            path: 'delivery',
            name: 'serviceYachtDelivery',
            component: YachtDelivery
          },
          {
            path: 'documents',
            name: 'serviceYachtDocuments',
            component: YachtDocuments
          },
          {
            path: 'finance',
            name: 'serviceYachtFinance',
            component: YachtFinance
          },
          {
            path: 'history',
            name: 'serviceYachtHistory',
            component: YachtHistory
          },
          {
            path: 'booking',
            name: 'serviceYachtBooking',
            component: YachtBooking
          },
          {
            path: 'photos',
            name: 'serviceYachtPhotos',
            component: YachtPhotos
          },
          {
            path: 'specs',
            name: 'serviceYachtSpecs',
            component: YachtSpecs
          },
          {
            path: 'comments',
            name: 'serviceYachtComments',
            component: YachtComments
          }
        ]
      },
      {
        path: 'stats',
        name: 'serviceStats',
        component: StatsIndex
      }
    ]
  }
]
